import { render } from "./RoundtripSearchForm.vue?vue&type=template&id=0fab823e"
import script from "./RoundtripSearchForm.vue?vue&type=script&lang=js"
export * from "./RoundtripSearchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__